export const REG_EXP = /^.{6,255}$/;
export const TEXT_ERRORS = {
	FILL: 'Fill in the fields.',
	MUST_BE_VALID: 'The password must be at least 6 characters and must contain Latin letters, numbers, at least one character "!@#$%^&*", one capital letter.',
	PASSWORD_MATCH: 'Passwords must match.'
};

export function getErrorMessage(errors) {
	let text = '';
	if (errors.length) errors.forEach(item => (text += `<span>${ item }</span>`));

	return text;
}
